module.exports = __webpack_public_path__ + "img/las-reservas5.1ca0c837.png";